export default "__VITE_ASSET__D7OO1b02__"